import React from 'react';
import Cookies from 'js-cookie';
import confetti from 'canvas-confetti';
import styles from './LiveResume.module.css';
import * as utils from '../../utils/utils';
import Sidebar from '../Sidebar/Sidebar';
import LiveResumeVouchVerification from './LiveResumeVouchVerification/LiveResumeVouchVerification';
import LiveResumeQuizVerification from './LiveResumeQuizVerification/LiveResumeQuizVerification';
import { FiStar } from 'react-icons/fi';
import LiveResumeVideoVerification from './LiveResumeVideoVerification/LiveResumeVideoVerification';

export default class LiveResume extends React.Component {

	constructor(props) {
		super(props);

		this.screens = {
			EntityList: 1,
			Composer: 2,
			VerificationChoice: 3,
			QuizVerification: 4,
			VideoVerification: 5,
			VouchVerification: 6,
			Score: 7,
			StructureSummary: 8,
		};

		this.verificationMethods = {
			Quiz: 1,
			Video: 2,
			Vouch: 3,
		};

		this.score = {
			NoScore: 0,
			Beginner: 1,
			Intermediate: 2,
			Advanced: 3,
		};

		this.state = {
			currentScreen: this.screens.EntityList,

			// liveResumeText: 'learned about knex.js migrations',
			// liveResumeText: 'as a referral coordinator, i sent 22 referrals today to different doctors from UNLV Health center in my 8 hour shift',
			// liveResumeText: 'worked with seed files in knex.js with node.js backend',
			liveResumeText: '',
			entities: [],
			selectedUserEntityID: '',

			currentLiveResumeID: 0,
			verificationMethod: null,

			gainedStructure: null,
			isStructureLoading: false,
			structureLoadError: '',

			isLoading: false,
			isEntityLoading: true,
			errorText: '',
			verificationErrorText: '',

			score: 0,
		};
	}

	componentDidMount() {
		if (!utils.isLoggedIn()) {
			window.location.href = '/signin';
			return;
		}

		this.loadMyEntities();
	}

	componentWillUnmount() {
	}

	// getQueryUserEntityID = () => {
	// 	const params = new URLSearchParams(window.location.search);
	// 	const value = Number(params.get('userEntityID'));

	// 	if (Number.isInteger(value) && value > 0) {
	// 		return value;
	// 	}

	// 	return null;
	// };

	loadMyEntities = () => {
		this.setState({
			isEntityLoading: true,
			errorText: '',
		}, () => {
			utils.sendRequest('/entity/getMyEntities', {})
				.then((responseData) => {
					const entities = (responseData.entities || []).map((item) => ({
						userEntityId: Number(item.userEntityId),
						name: item.name || 'Untitled Entity',
					}));

					// const queryEntityID = this.getQueryUserEntityID();
					// const hasQueryEntity = entities.some((item) => item.userEntityId === queryEntityID);
					// const selectedUserEntityID = hasQueryEntity
					// 	? String(queryEntityID)
					// 	: (entities[0] ? String(entities[0].userEntityId) : '');

					this.setState({
						entities,
						// selectedUserEntityID,
						isEntityLoading: false,
					});
				})
				.catch((error) => {
					this.setState({
						isEntityLoading: false,
						errorText: error && error.message ? error.message : 'Could not load your entities right now.',
					});
				});
		});
	};

	onInputChange = (event) => {
		this.setState({
			liveResumeText: event.target.value,
			errorText: '',
		});
	};

	onEntityChange = (event) => {
		this.setState({
			selectedUserEntityID: event.target.value,
			errorText: '',
		});
	};

	handleEntityListSelect = (userEntityId) => {
		this.setState({
			selectedUserEntityID: String(userEntityId),
			errorText: '',
		});
	};

	goToComposerFromEntityList = () => {
		const userEntityID = Number(this.state.selectedUserEntityID);

		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			this.setState({
				errorText: 'Please select an entity to continue.',
			});
			return;
		}

		this.setState({
			currentScreen: this.screens.Composer,
			errorText: '',
			verificationErrorText: '',
		});
	};

	handleTextKeyDown = (event) => {
		if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
			this.saveLiveResume();
		}
	};

	triggerSavedConfetti = () => {
		confetti({ particleCount: 150, spread: 70, origin: { y: 0.6 } });
	};

	openVouchScreen = () => {
		this.teardownVideoVerification();

		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.VouchFriends,
			verificationMethod: 'vouch',
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
		}, this.loadPeopleForVouch);
	};

	loadLiveResumeStructure = async () => {
		const liveResumeID = Number(this.state.currentLiveResumeID);

		if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
			this.setState({
				isStructureLoading: false,
				gainedStructure: null,
				structureLoadError: 'No live resume was found for structure loading. Please save again.',
			});
			return;
		}

		this.setState({
			isStructureLoading: true,
			structureLoadError: '',
			errorText: '',
		});

		try {
			const response = await utils.sendRequest('/liveResume/getLiveResumeStructure', {
				userEntityLiveResumeID: liveResumeID,
			});

			if (!response || response.status !== 'ready' || !response.structure) {
				this.setState({
					isStructureLoading: false,
					gainedStructure: null,
					structureLoadError: 'Structure is still being generated. Please retry in a few seconds.',
				});
				return;
			}

			this.setState({
				isStructureLoading: false,
				gainedStructure: response.structure,
				structureLoadError: '',
			});
		} catch (error) {
			this.setState({
				isStructureLoading: false,
				gainedStructure: null,
				structureLoadError: error && error.message ? error.message : 'Could not load generated structure right now.',
			});
		}
	};

	restartVerification = () => {
		if (!this.state.currentLiveResumeID || !this.state.verificationQuestions.length) {
			this.failVerification('No live resume is loaded for verification. Please save again.');
			return;
		}

		this.setState({
			errorText: '',
			verificationErrorText: '',
			verificationAnswersByQuestionID: {},
			selectedAnswersByQuestionID: {},
			learningIntentQuestionIDs: [],
			verificationMisses: [],
		}, this.startVerificationFlow);
	};

	saveLiveResume = () => {
		const liveResumeText = this.state.liveResumeText.trim();

		if (liveResumeText === '') {
			this.setState({
				errorText: 'Please enter a live resume update before saving.',
			});
			return;
		}

		const userEntityID = Number(this.state.selectedUserEntityID);
		if (!Number.isInteger(userEntityID) || userEntityID <= 0) {
			this.setState({
				errorText: 'Please select a user entity first.',
			});
			return;
		}

		this.setState({
			isLoading: true,
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
		}, async () => {
			try {
				const saveResponse = await utils.sendRequest('/liveResume/saveLiveResume', {
					userEntityID,
					liveResumeText,
				});
				// const saveResponse = {
				// 	userEntityLiveResumeID: 123, // todo: Mocked response for testing
				// };

				const liveResumeID = Number(saveResponse && saveResponse.userEntityLiveResumeID);
				if (!Number.isInteger(liveResumeID) || liveResumeID <= 0) {
					throw new Error('Save succeeded but no liveResumeID was returned.');
				}

				this.setState({
					currentScreen: this.screens.VerificationChoice,
					currentLiveResumeID: liveResumeID,
					isLoading: false,
				});
			}
			catch (error) {
				this.setState({
					currentScreen: this.screens.Composer,
					isLoading: false,
					errorText: error && error.message ? error.message : 'Could not save live resume right now. Please try again.',
				});
			}
		});
	};

	goToDashboard = () => {
		window.location.href = '/dashboard';
	};

	startVideoVerification = () => {
		this.setState({
			currentScreen: this.screens.VideoVerification,
		});
	};

	continueVerification = (score) => {
		this.setState({
			score: Number(score) || 0,
			currentScreen: this.screens.Score,
		}, this.loadLiveResumeStructure);
	};

	gotoLiveResumeStructure = () => {
		this.setState({
			currentScreen: this.screens.StructureSummary,
		});
	};

	goBackToVerificationChoice = () => {
		if (this.state.recordedVideoURL) {
			URL.revokeObjectURL(this.state.recordedVideoURL);
		}

		this.stopVideoRecording();
		this.stopVideoStream();

		this.clearAllVerificationTimers();
		this.setState({
			currentScreen: this.screens.VerificationChoice,
			isLoading: false,
			errorText: '',
			verificationErrorText: '',
			vouchSuccessText: '',
			isVideoRecording: false,
			videoPermissionState: 'idle',
			recordedVideoBlob: null,
			recordedVideoURL: '',
			recordedVideoMimeType: '',
		});
	};

	getStepIndex = (screen) => {
		const activeScreen = screen || this.state.currentScreen;
		const verificationScreens = new Set([
			this.screens.VerificationChoice,
			this.screens.VouchFriends,
			this.screens.VideoVerification,
			this.screens.Processing,
			this.screens.Verification,
		]);

		if (verificationScreens.has(activeScreen)) {
			return 1;
		}

		const completionScreens = new Set([
			this.screens.Score,
			this.screens.StructureSummary,
		]);

		if (completionScreens.has(activeScreen)) {
			return 2;
		}

		return 0;
	};

	renderDot = (screen) => {
		const stepIndex = this.getStepIndex(screen);

		return (
			<div className={styles.stepRow}>
				<div className={`${styles.stepDot} ${stepIndex >= 0 ? styles.stepDotActive : ''}`} />
				<div className={styles.stepLine} />
				<div className={`${styles.stepDot} ${stepIndex >= 1 ? styles.stepDotActive : ''}`} />
				<div className={styles.stepLine} />
				<div className={`${styles.stepDot} ${stepIndex >= 2 ? styles.stepDotActive : ''}`} />
			</div>
		);
	};

	// renderScreenLayout = ({
	// 	screen,
	// 	title,
	// 	subtitle,
	// 	caption,
	// 	formTitle,
	// 	formText,
	// 	errorText,
	// 	children,
	// }) => {
	// 	return (
	// 		<>
	// 			<section className={styles.headerPanel}>
	// 				<h1 className={styles.title}>{title}</h1>
	// 				<p className={styles.subtitle}>{subtitle}</p>

	// 				<div className={styles.userRow}>
	// 					<span className={styles.userCaption}>{caption}</span>
	// 				</div>
	// 			</section>

	// 			<section className={styles.mainCardPanel}>
	// 				{this.renderDot(screen)}
	// 				<h2 className={styles.formTitle}>{formTitle}</h2>
	// 				<p className={styles.formText}>{formText}</p>

	// 				{children}

	// 				{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
	// 			</section>
	// 		</>
	// 	);
	// };

	renderEntityListScreen = () => {
		const {
			entities,
			selectedUserEntityID,
			isEntityLoading,
			errorText,
		} = this.state;

		return (
			<>
				<section className={styles.headerPanel}>
					<h1 className={styles.title}>Capture your latest contribution while it is fresh.</h1>
					<p className={styles.subtitle}>Start by choosing the profile this check-in belongs to.</p>

					<div className={styles.userRow}>
						<span className={styles.userCaption}>Pick one entity and continue.</span>
					</div>
				</section>

				<section className={styles.mainCardPanel}>
					{this.renderDot(this.screens.EntityList)}
					<h2 className={styles.formTitle}>Check-In For</h2>
					<p className={styles.formText}>What is this check-in for?</p>

					<div className={styles.entityListWrap}>
						<div className={styles.entityListCard}>
							{isEntityLoading && <div className={styles.structureText}>Loading entities...</div>}

							{!isEntityLoading && entities.length === 0 && (
								<div className={styles.structureText}>No entities found right now. Please refresh and try again.</div>
							)}

							{!isEntityLoading && entities.length > 0 && (
								<div className={styles.entityOptionList}>
									{entities.map((entity) => {
										const isSelected = String(entity.userEntityId) === String(selectedUserEntityID);

										return (
											<button
												type='button'
												key={`entity-option-${entity.userEntityId}`}
												className={`${styles.entityOptionButton} ${isSelected ? styles.entityOptionButtonSelected : ''}`}
												onClick={() => this.handleEntityListSelect(entity.userEntityId)}
											>
												<span className={`${styles.entityOptionCircle} ${isSelected ? styles.entityOptionCircleSelected : ''}`} />
												<span className={styles.entityOptionText}>{entity.name}</span>
											</button>
										);
									})}
								</div>
							)}
						</div>

						<button
							className={styles.primaryButton}
							onClick={this.goToComposerFromEntityList}
							disabled={isEntityLoading || entities.length === 0}
						>
							Next
						</button>
					</div>

					{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
				</section>
			</>
		);
	};

	renderComposerScreen = () => {
		const {
			liveResumeText,
			isLoading,
			errorText,
		} = this.state;

		return (
			<>
				{/* <section className={styles.headerPanel}>
					<h1 className={styles.title}>Capture your latest contribution while it is fresh.</h1>
					<p className={styles.subtitle}>Write a concise update on what you just accomplished.</p>

					<div className={styles.userRow}>
						<span className={styles.userCaption}>Focus on impact, outcomes, and ownership.</span>
					</div>
				</section> */}

				<section className={styles.mainCardPanel}>
					{this.renderDot(this.screens.Composer)}
					<h2 className={styles.formTitle}>Live Resume Check-In</h2>
					{/* <p className={styles.formText}>Write a concise update on what you've just accomplished: impact, outcomes, and ownership.</p> */}
					<p className={styles.formText}>Write a concise update about what you've just accomplished, what you're learning / building / doing. Focus on impact, outcomes, and ownership.</p>

					<div className={styles.form}>
						<div className={styles.fieldGroup}>
							<label className={styles.label} htmlFor='live-resume-text'>Live Resume Update</label>
							<textarea
								id='live-resume-text'
								name='liveResumeText'
								className={styles.textArea}
								placeholder='Example: Led migration to typed APIs across 4 services, reduced production incidents by 35%, and mentored two engineers through rollout.'
								value={liveResumeText}
								onChange={this.onInputChange}
								onKeyDown={this.handleTextKeyDown}
							/>
						</div>

						<button className={styles.primaryButton} onClick={this.saveLiveResume} disabled={isLoading}>
							{isLoading ? 'Saving...' : 'Save Live Resume'}
						</button>

						<p className={styles.hintText}>Tip: Press Ctrl/Cmd + Enter to save quickly.</p>
					</div>

					{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
				</section>
			</>
		);
	};

	startQuizVerification = () => {
        if (!this.state.currentLiveResumeID) {
            this.setState({
                errorText: 'No live resume item is loaded. Please save again.',
                verificationErrorText: '',
            });
            return;
        }

        this.setState({
            verificationMethod: this.verificationMethods.Quiz,
			currentScreen: this.screens.QuizVerification,
        });
    };

	renderVerificationChoiceScreen = () => {
		const {
			isLoading,
			errorText
		} = this.state;

		return (
			<>
				<section className={styles.mainCardPanel}>
					{this.renderDot(this.screens.VerificationChoice)}
					<h2 className={styles.formTitle}>Choose Verification Method</h2>
					<p className={styles.formText}>Verify now using a quiz, a short video, or friend vouching.</p>

					<div className={styles.methodChoiceWrap}>
						<div className={styles.methodChoiceCard}>
							<h3 className={styles.methodChoiceTitle}>Verify now with a 3 question quiz</h3>
							<p className={styles.methodChoiceText}>Immediate verification using generated questions from your live resume entry.</p>
							<button className={styles.primaryButton} onClick={this.startQuizVerification} disabled={isLoading}>
								Start Quiz Verification
							</button>
						</div>

						<div className={styles.methodChoiceCard}>
							<h3 className={styles.methodChoiceTitle}>Verify now by recording a short video</h3>
							<p className={styles.methodChoiceText}>Record up to 30 seconds explaining what you accomplished in your own words.</p>
							<button className={styles.primaryButton} onClick={this.startVideoVerification} disabled={isLoading}>
								Record Verification Video
							</button>
						</div>

						{/* todo */}
						{/* <div className={styles.methodChoiceCard}>
							<h3 className={styles.methodChoiceTitle}>Verify by having 2 people vouch</h3>
							<p className={styles.methodChoiceText}>Choose connections, invite by email, or combine both. Maximum total is 2 people.</p>
							<button className={styles.primaryButton} onClick={this.openVouchScreen} disabled={isLoading}>
								Have Friends Vouch
							</button>
						</div> */}
					</div>

					{errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
				</section>
			</>
		);
	};

	getVerificationScoreLabel = (correctAnswerCount) => {
		if (correctAnswerCount >= 3) {
			return 'Advanced';
		}

		if (correctAnswerCount === 2) {
			return 'Intermediate';
		}

		if (correctAnswerCount === 1) {
			return 'Beginner';
		}

		return 'No Score';
	};

	renderScoreScreen = () => {
		const score = Math.max(0, Math.min(3, Number(this.state.score) || 0));
		const scoreLabel = this.getVerificationScoreLabel(score);
		const scoreMessage = score === this.score.Advanced
			? 'You cleared the quiz and can move on to structure generation.'
			: 'You still passed verification, and the result is ready to review.';

		return (
			<>
				<section className={styles.mainCardPanel}>
					{this.renderDot(this.state.currentScreen)}
					<h2 className={styles.formTitle}>Verification complete</h2>
					<p className={styles.formText}>Review your verification score below</p>

					<div className={styles.verificationWrap}>
						<div className={styles.successIcon}>Verified</div>
						{/* <p className={styles.successText}>{scoreMessage}</p> */}

						<div className={styles.scoreCard} style={{ marginTop: '12px' }}>
							<h3 className={styles.successTitle}>{scoreLabel}</h3>
							{/* <div className={styles.structureTitle}>Score</div> */}
							<div className={styles.structureText} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
								{[1, 2, 3].map((starIndex) => {
									const isFilled = starIndex <= score;

									return (
										<FiStar
											key={`score-star-${starIndex}`}
											size={32}
											strokeWidth={1.8}
											fill={isFilled ? 'currentColor' : 'none'}
											style={{ color: isFilled ? 'var(--primary)' : 'rgba(148, 163, 184, 0.9)' }}
										/>
									);
								})}
							</div>
						</div>

						<div className={styles.failureActions} style={{ marginTop: '18px' }}>
							<button className={styles.primaryButton} onClick={this.gotoLiveResumeStructure}>
								Continue
							</button>
						</div>
					</div>
				</section>
			</>
		);
	};

	renderStructureSummaryScreen = () => {
		const {
			isStructureLoading,
			gainedStructure,
			structureLoadError,
		} = this.state;

		if (isStructureLoading) {
			return (
				<>
					<section className={styles.mainCardPanel}>
						{this.renderDot(this.screens.StructureSummary)}
						<h2 className={styles.formTitle}>Generated Structure Summary</h2>
						<p className={styles.formText}>Building your summary from verified data.</p>

						<div className={styles.successWrap}>
							<div className={styles.successIcon}>Preparing</div>
							<h3 className={styles.successTitle}>Building your summary</h3>
							<p className={styles.successText}>We are collecting your skills, tools, domains, soft skills, impacts, and achievements.</p>
						</div>
					</section>
				</>
			);
		}

		if (!gainedStructure) {
			return (
				<>
					<section className={styles.mainCardPanel}>
						{this.renderDot(this.screens.StructureSummary)}
						<h2 className={styles.formTitle}>Generated Structure Summary</h2>
						<p className={styles.formText}>Structure is not ready yet.</p>

						<div className={styles.failureWrap}>
							<div className={styles.failureBadge}>Structure pending</div>
							<h3 className={styles.failureTitle}>Not ready yet</h3>
							<p className={styles.failureText}>{structureLoadError || 'Structure generation is still in progress.'}</p>

							<div className={styles.failureActions}>
								<button className={styles.primaryButton} onClick={this.loadLiveResumeStructure}>
									Retry Loading Structure
								</button>
							</div>
						</div>
					</section>
				</>
			);
		}

		const skills = Array.isArray(gainedStructure.skills) ? gainedStructure.skills : [];
		const tools = Array.isArray(gainedStructure.tools) ? gainedStructure.tools : [];
		const domains = Array.isArray(gainedStructure.domains) ? gainedStructure.domains : [];
		const softSkills = Array.isArray(gainedStructure.softSkills) ? gainedStructure.softSkills : [];
		const impacts = Array.isArray(gainedStructure.impacts) ? gainedStructure.impacts : [];
		const achievements = Array.isArray(gainedStructure.achievements) ? gainedStructure.achievements : [];

		return (
			<>
				<section className={styles.mainCardPanel}>
					{this.renderDot(this.screens.StructureSummary)}
					<h2 className={styles.formTitle}>Generated Structure Summary</h2>
					<p className={styles.formText}>This summary is generated from your verified update.</p>

					<div className={styles.structureWrap}>
						<div className={styles.structureCard}>
							<h3 className={styles.structureTitle}>Skills</h3>
							<p className={styles.structureText}>{skills.length ? skills.map((item) => item.name).join(', ') : 'No skills captured.'}</p>
						</div>

						<div className={styles.structureCard}>
							<h3 className={styles.structureTitle}>Tools</h3>
							<p className={styles.structureText}>{tools.length ? tools.map((item) => item.name).join(', ') : 'No tools captured.'}</p>
						</div>

						<div className={styles.structureCard}>
							<h3 className={styles.structureTitle}>Domains</h3>
							<p className={styles.structureText}>{domains.length ? domains.map((item) => item.name).join(', ') : 'No domains captured.'}</p>
						</div>

						<div className={styles.structureCard}>
							<h3 className={styles.structureTitle}>Soft Skills</h3>
							<p className={styles.structureText}>{softSkills.length ? softSkills.map((item) => item.name).join(', ') : 'No soft skills captured.'}</p>
						</div>

						<div className={styles.structureCard}>
							<h3 className={styles.structureTitle}>Impacts</h3>
							<p className={styles.structureText}>{impacts.length ? impacts.map((item) => item.impact).join(' | ') : 'No impacts captured.'}</p>
						</div>

						<div className={styles.structureCard}>
							<h3 className={styles.structureTitle}>Achievements</h3>
							<p className={styles.structureText}>{achievements.length ? achievements.map((item) => item.achievement).join(' | ') : 'No achievements captured.'}</p>
						</div>

						<button className={styles.primaryButton} onClick={this.goToDashboard}>
							Back To Dashboard
						</button>
						{/* <button className={styles.secondaryButton} onClick={this.goBackToComposer}>
							Save Another Update
						</button> */}
					</div>
				</section>
			</>
		);
	};

	renderCurrentScreen = () => {
		const {
			currentScreen,
			currentLiveResumeID,
		} = this.state;

		if ( currentScreen === this.screens.EntityList ) {
			return this.renderEntityListScreen();
		}
		else if ( currentScreen === this.screens.Composer ) {
			return this.renderComposerScreen();
		}
		else if ( currentScreen === this.screens.VerificationChoice ) {
			return this.renderVerificationChoiceScreen();
		}
		else if ( currentScreen === this.screens.QuizVerification ) {
			return (
				<LiveResumeQuizVerification
					liveResumeID={currentLiveResumeID}
					onContinueVerification={this.continueVerification}
				/>
			);
		}
		else if ( currentScreen === this.screens.VideoVerification ) {
			return (
				<LiveResumeVideoVerification
					liveResumeID={currentLiveResumeID}
					onContinueVerification={this.continueVerification}
				/>
			);
		}
		else if ( currentScreen === this.screens.VouchVerification ) {
			return (
				<LiveResumeVouchVerification />
			);
		}
		else if ( currentScreen === this.screens.Score ) {
			return this.renderScoreScreen();
		}
		else if ( currentScreen === this.screens.StructureSummary ) {
			return this.renderStructureSummaryScreen();
		}
	};

	render() {
		return (
			<div className={styles.pageContainer}>
				<Sidebar />

				<div className={styles.glowTop} />
				<div className={styles.glowBottom} />

				<div className={styles.layoutShell}>
					{this.renderCurrentScreen()}
				</div>
			</div>
		);
	}
}
